module.exports = __webpack_public_path__ + "img/duka.b765c804.png";